/* eslint-disable react/prop-types */
import React from 'react';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';

import { useCtxGlobal } from '@client/app/Container';
import { createRecentSearches } from '@modals/factories';

export default function RecentSearches({ searches }) {
  const { openModal, isMobile, isAuth } = useCtxGlobal();
  const nearbyCheck = isAuth && searches.filter((search) => search.nearby !== null).length > 0;
  const open = () => {
    trackGTMEvents({
      category: 'Interaction',
      action: 'OpenModal',
      label: 'SeeRecentSearches',
    });
    openModal(createRecentSearches({
      isMobile,
      searches,
      nearbyCheck,
    }));
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      open();
    }
  };

  return (
    <button type="button" name="Apri le tue ricerche recenti" className="recentSearchesHandle pr--m pl--m tp-s--s tp-w--m c-txt--w" onClick={open} onKeyUp={onKeyPress} aria-label="Ricerche recenti" aria-haspopup="dialog">
      Ricerche recenti
    </button>
  );
}
